import { FormGroup } from "@mui/material";
import { DropdownFilter } from "../../../../../../components/dataGridFilter/filter-components/DropdownFilter";
import { OperatorBasedDropdownFilter } from "../../../../../../components/dataGridFilter/filter-components/OperatorBasedDropdownFilter";
import { SwitchFilter } from "../../../../../../components/dataGridFilter/filter-components/SwitchFilter";

export const FilterGroup2 = () => {
  const baseKey =
    "pages.inventoryManagement.inventory.list.filters.filterGroup2";

  return (
    <FormGroup
      sx={{
        bgcolor: "customBackground.box",
        borderRadius: 1,
        mb: 2,
        padding: 2,
        display: "flex",
        gap: 2,
      }}
    >
      <DropdownFilter
        name="hasSalesRank"
        labelKey={`${baseKey}.hasSalesRank.title`}
        operator="eq"
        hideLabelInChip
        options={[
          { value: "true", label: `${baseKey}.hasSalesRank.options.true` },
          { value: "false", label: `${baseKey}.hasSalesRank.options.false` },
        ]}
      />
      <OperatorBasedDropdownFilter
        name="supplier.id.supplierId"
        labelKey={`${baseKey}.amazonSeller.title`}
        value="Amazon"
        options={[
          {
            label: `${baseKey}.amazonSeller.options.true`,
            operator: "contains",
          },
          {
            label: `${baseKey}.amazonSeller.options.false`,
            operator: "ncontains",
          },
        ]}
      />
      <DropdownFilter
        name="supplier.shipsFromAmazon"
        labelKey={`${baseKey}.fbaProducts.title`}
        operator="eq"
        hideLabelInChip
        options={[
          { value: "true", label: `${baseKey}.fbaProducts.options.true` },
          { value: "false", label: `${baseKey}.fbaProducts.options.false` },
        ]}
      />
      <SwitchFilter
        name="supplierNameStartsWithBrandName"
        labelKey={`${baseKey}.sellerBrandName`}
      />
      <SwitchFilter
        name="sameBuyBoxWinner"
        labelKey={`${baseKey}.sameBuyBoxWinner`}
      />
      <SwitchFilter
        name="marketplaceProduct.product.bestSeller"
        labelKey={`${baseKey}.bestSeller`}
      />
      <SwitchFilter
        name="marketplaceProduct.product.amazonsChoice"
        labelKey={`${baseKey}.amazonsChoice`}
      />
    </FormGroup>
  );
};
